// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".column.centered-full[data-v-6601b476]{display:flex;align-items:center;justify-content:center;text-align:center}.column.no-margins[data-v-6601b476]{padding:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
